import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Client } from "../../api/sms-api";
import {
  NonPaginatedCRUDState,
  initialNonPaginatedCRUDState,
} from "store/CRUDStore";
import { ErrorWrapper } from "errors/errors";

interface ClientCustomLogoSettingsState extends NonPaginatedCRUDState<Client> {
  updateLoading: boolean;
  getLoading: boolean;
}

export const initialState: ClientCustomLogoSettingsState = {
  ...initialNonPaginatedCRUDState,
  updateLoading: false,
  getLoading: false,
};

export const slice = createSlice({
  name: "clientCustomLogoSettings",
  initialState,
  reducers: {
    updateCustomLogoSettingStart: (state) => {
      state.updateLoading = true;
    },
    updateCustomLogoSettingSuccess: (state, action) => {
      state.item = action.payload;
      state.updateLoading = false;
    },
    updateCustomLogoSettingError: (
      state,
      _action: PayloadAction<ErrorWrapper>
    ) => {
      state.updateLoading = false;
    },
    getCustomLogoSettingStart: (state) => {
      state.getLoading = true;
    },
    getCustomLogoSettingSuccess: (state, action) => {
      state.item = action.payload;
      state.getLoading = false;
    },
    getCustomLogoSettingError: (
      state,
      _action: PayloadAction<ErrorWrapper>
    ) => {
      state.getLoading = false;
    },
    clearCustomLogo: (state) => {
      if (state.item) {
        state.item.customLogoUrl = undefined;
      }
    },
  },
});

export const {
  updateCustomLogoSettingStart,
  updateCustomLogoSettingSuccess,
  updateCustomLogoSettingError,
  getCustomLogoSettingStart,
  getCustomLogoSettingSuccess,
  getCustomLogoSettingError,
  clearCustomLogo,
} = slice.actions;

export default slice.reducer;
